// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11f3b2e1","829":"fe1fed0c","840":"ef3b57e7","879":"49af4f67"}[chunkId] + ".chunk.js";
};